import { FormattedMessage } from "react-intl";
import { Link, Route, Switch, useParams } from "react-router-dom";
import { Col } from "reactstrap";
import { CardBody } from "reactstrap";
import { Card } from "reactstrap";
import { Row } from "reactstrap";
import Avatar from "../../Components/Avatar";
import DataLoader from "../../Components/DataLoader";
import { MenteeEdit } from "../../profile/Mentee";
import Mentee from "./Mentee";

function MenteeCard({ value }) {
	return <Card>
		<CardBody>
			<Avatar user={value.user} className="mb-3" />
			<h3>{value.user.name}</h3>
			
			<p>{value.about}</p>
			
			<p className="mb-0">
				<Link to={"/mentee/"+value.user.id}>
					<FormattedMessage id="MORE" />
				</Link>
			</p>
		</CardBody>
	</Card>;
}

export default function Mentees() {
	return <Switch>
		<Route path="/mentee/:id/edit" component={MenteeEditPage} />
		<Route path="/mentee/:id" component={Mentee} />
		<Row>
			<DataLoader url="/mentee">
			{
				row => <Col md="4" key={row.user.id}>
					<MenteeCard  value={row} />
				</Col>
			}
			</DataLoader>
		</Row>
	</Switch>;
}

export function MenteeEditPage() {
	const { id } = useParams();
	
	return <MenteeEdit
		id={id}
	/>;
}
